import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { Button, ButtonToolbar, ButtonGroup } from 'react-bootstrap';
import { IProduct } from '../Types';
import * as Site from '../../../shared/Site';

interface ProductListRowProps {
    product: IProduct;
    key: number;
    onEdit: (id: any) => void;
    onViewLogs: (id: number) => void;
}

const ProductListRow = (props: ProductListRowProps) => {
    let rowClass = Site.getOrderCssClass(props.product.site.id);

    return (
        <tr className={rowClass}>
            <td>{props.product.name}</td>
            <td>{props.product.description}</td>
            <td>{props.product.numberOfImages}</td>
            <td>
                <i className="material-icons">{props.product.isDiscontinued ? 'done' : ''}</i>
            </td>
            <td>{props.product.type.name}</td>
            <td>{props.product.invoiceProductType.name}</td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <ButtonGroup className="center">
                        <Button
                            onClick={props.onEdit.bind(null, props.product.id)}
                            bsStyle="primary"
                        >
                            <i className="material-icons">edit</i>{' '}
                            {Translate('products/list/row/button-label/edit')}
                        </Button>
                        <Button onClick={() => props.onViewLogs(props.product.id)} bsStyle="info">
                            <i className="material-icons">list</i>{' '}
                            {Translate('products/list/row/button-label/logs')}
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default ProductListRow;
